(function() {
    angular
        .module("app")
        .controller("MoveToCustomerModalController", MoveToCustomerModalController)

    MoveToCustomerModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "devicesService",
        "deviceIDs",
        "success",
        "failure"
    ]

    function MoveToCustomerModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        devicesService,
        deviceIDs,
        success,
        failure
    ){
        "use strict"

        $scope.deviceIDs = deviceIDs

        $scope.moveDevicesFormData = {
            customerID: undefined
        }

        $scope.moveDevices = function() {

            $scope.submitted = true

            if ($scope.moveDevicesForm.$valid) {
                $uibModalInstance.close(devicesService.moveDevices($scope.deviceIDs, $scope.moveDevicesFormData.customerID, success, failure))
            }
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
